import Vue from "vue";
import {
  API_ROOT,
  API_ROOT_V2,
  responsemanagement,
  unscheduledAppointment,
  appointmentCancel,
  pi,
  studies,
  participantManagement,
  participants,
  piAppointment,
  telehealth2,
  appointment,
  startvideocall,
  updatecallstarttime,
  setting,
  site,
  availability,
  recurring,
  recurringConfiguration,
  taskNotificationDisable,
  participant,
  studyManagement,
  archive,
  archivestop,
  archivestart,
  archivingdetails,
  downloadtelehealthrecord,
  recordingUrl,
  siteteammembers,
  invite,
  recordVideo,
  contactDetails,
  sites,
  slots,
  pId,
  taskId,
  taskInstanceId,
  offset,
  statusList,
  checkLegacy,
  studyId,
  reasonList,
  renewSingleUseToken,
  mediaId
} from "./urls";

const appointmentResource = Vue.resource(`${API_ROOT}${responsemanagement}${unscheduledAppointment}/${pi}`, {});

const cancelAppointmentResource = Vue.resource(`${API_ROOT}${responsemanagement}${appointmentCancel}/${pi}`, {});

const disqualifyParticipantResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const activeParticipantWithoutAppResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getAppointmentResource = Vue.resource(`${API_ROOT}${responsemanagement}${piAppointment}`, {});

const getVideoCallKeys = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${appointment}/${startvideocall}`, {
  update: {
    method: "PUT"
  }
});

const updateCallTime = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${updatecallstarttime}`, {
  update: {
    method: "PUT"
  }
});

const saveAppointmentAvailability = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}`, {
  update: {
    method: "PUT"
  }
});

const printDocumentPdf = Vue.resource(
  `${API_ROOT}${studyManagement}${renewSingleUseToken}?${mediaId}={mediaId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const saveRecurringAppointmentAvailability = Vue.resource(
  `${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}/${recurring}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const deleteAppointmentAvailability = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}`, {
  update: {
    method: "PUT"
  }
});

const getAppointmentAvailabilityList = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}`, {});

const getAppointmentsForTelehealth = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${appointment}/${pi}`);

const getAppointmentsForVisits = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${appointment}/${pi}/pagination`);

const saveTelehealthAppointmentSetting = Vue.resource(`${API_ROOT}${responsemanagement}${site}/${setting}`, {}, { update: { method: "PUT" } });

const getTelehealthAppointmentSetting = Vue.resource(`${API_ROOT}${responsemanagement}${site}/${setting}`);

const getRecurringAvailabilityDetail = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}/${recurringConfiguration}`);

const deleteRecurringAppointmentAvailability = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/siteID}/${availability}/${recurring}`);

const updateTelehealthAppointmentStatusResource = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${appointment}{/appointmentId}`, {}, { update: { method: "PUT" } });
const startTHcallRecordingResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${archive}/${archivestart}`, {}, { update: { method: "POST" } });
const stopTHcallRecordingResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${archive}{/archiveId}/${archivestop}`, {}, { update: { method: "POST" } });
const sendArchiveDataFact = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${archivingdetails}`, {}, { update: { method: "POST" } });
const updateArchiveDataFact = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${archivingdetails}`, {}, { update: { method: "PUT" } });
const getArchiveUrlResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${studies}/${telehealth2}/${recordingUrl}`, {}, { update: { method: "GET" } });

const downloadArchiveResource = Vue.resource(
  `${API_ROOT_V2}${responsemanagement}${studies}/${telehealth2}/${downloadtelehealthrecord}`,
  {},
  {
    update: {
      method: "GET"
    }
  }
);

const getDisabledListResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}{/studyId1}/${participant}{/participantId}/${taskNotificationDisable}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getTeamMembersResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${appointment}/${siteteammembers}`);

const addToCallResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${appointment}/${siteteammembers}/${invite}`, {
  update: {
    method: "PUT"
  }
});

const getRecordingResource = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${recordVideo}{/id1}`);

const contactDetailsResource = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${studies}/${appointment}{/appointmentId}/${contactDetails}?pId={pId}`);

const PI_IDResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${siteteammembers}`);

const telehealthVisitSlotResource = Vue.resource(`${API_ROOT}${responsemanagement}${studies}{/studyId}/${telehealth2}/${site}/{siteId}/${appointment}/${slots}?${pId}={pId}&${taskId}={taskId}&${taskInstanceId}={taskInstanceId}&${offset}={offset}&timezone={timezone}`);

const scheduleAppointmentParticipantResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${telehealth2}/${site}/{siteId}/${appointment}?${pId}={pId}&isScheduledOutsideCompletionWindow=false`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getVisitAppoitmentResource = Vue.resource(`${API_ROOT}${responsemanagement}${studies}/{studyId}/${telehealth2}/${site}{/siteId}/${appointment}{/appointmentId}?pId={pId}`);

const reScheduleAppointmentParticipantResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${telehealth2}/${site}/{siteId}/${appointment}?${pId}={pId}&isReschedule=true&rescheduleId={rescheduleId}&isScheduledOutsideCompletionWindow=false`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const updateVisitAppoitmentResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${telehealth2}/${site}{/siteId}/${appointment}{/appointmentId}?pId={pId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const deleteVisitAppoitmentResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${telehealth2}/${site}{/siteId}/${appointment}{/appointmentId}?pId={pId}`,
  {},
  {
    update: {
      method: "DELETE"
    }
  }
);

const getStatusListUrl = Vue.resource(`${API_ROOT_V2}${participantManagement}${statusList}{/studyId}`);

const getReasonListUrl = Vue.resource(`${API_ROOT_V2}${participantManagement}${reasonList}/${studyId}{/studyId}`);

const legacyData = Vue.resource(`${API_ROOT_V2}${participantManagement}${checkLegacy}{/studyId}`);

export function appointmentFact(participantId, data) {
  return appointmentResource.save(
    {
      pId: participantId
    },
    data
  );
}

export function cancelAppointmentFact(participantId, data) {
  return cancelAppointmentResource.save(
    {
      pId: participantId
    },
    data
  );
}

export function disqualifyFact(participantId, studyID, data) {
  return disqualifyParticipantResource.update(
    {
      studyId: studyID,
      participantId
    },
    data
  );
}

export function activeWithoutApp(participantId, studyID, data) {
  return activeParticipantWithoutAppResource.update(
    {
      studyId: studyID,
      participantId
    },
    data
  );
}

export function getAppointmentDetailsFact(participantId) {
  return getAppointmentResource.get({
    pId: participantId
  });
}

export function getVideoCallSession(queryParams, data) {
  const queryString = {
    pId: queryParams.pid,
    offset: queryParams.offset,
    appointmentId: queryParams.appointmentId,
    deviceRegistrationStatus: queryParams.deviceRegistrationStatus
  };
  if (queryParams.deviceRegistrationStatus != undefined) {
    queryString.deviceRegistrationStatus = queryParams.deviceRegistrationStatus;
  }
  return getVideoCallKeys.save(queryString, data);
}

export function updateTelehealthCallStartTime(sessId, callStTime, pId) {
  return updateCallTime.save(
    {
      pId: pId,
      telehealthSessionId: sessId,
      callStartTime: callStTime
    },
    {}
  );
}

export function saveTelehealthAvailability(data) {
  const siteID = data.siteId;
  return saveAppointmentAvailability.save(
    {
      siteID,
      pId: data.piId,
      studyId: data.studyId
    },
    data
  );
}

export function saveTelehealthRecurringAvailability(data) {
  const siteID = data.siteId;
  return saveRecurringAppointmentAvailability.save(
    {
      siteID,
      pId: data.piId,
      studyId: data.studyId
    },
    data
  );
}

export function updateTelehealthAvailability(data) {
  const siteID = data.siteId;
  return saveAppointmentAvailability.update(
    {
      siteID,
      id: data.id,
      pId: data.piId,
      studyId: data.studyId
    },
    data
  );
}

export function printAgreementDocument(data) {
  return printDocumentPdf.update(data, null);
}

export function updateTelehealthRecurringAvailability(data) {
  const siteID = data.siteId;
  return saveRecurringAppointmentAvailability.update(
    {
      siteID,
      id: data.id,
      pId: data.piId,
      studyId: data.studyId
    },
    data
  );
}

export function deleteTelehealthAvailability(data) {
  const siteID = data.siteId;
  return deleteAppointmentAvailability.delete({
    siteID,
    id: data.id,
    pId: data.piId,
    studyId: data.studyId
  });
}

export function getTelehealthAvailabilityList(data) {
  const siteID = data.siteId;
  return getAppointmentAvailabilityList.get({
    siteID,
    pId: data.pId,
    startDate: data.startDate,
    endDate: data.endDate,
    siteId: data.siteId,
    studyId: data.studyId
  });
}

export function getTelehealthAppointmentList(data) {
  let getParams = {
    siteId: data.siteId,
    pId: data.pId,
    studyId: data.studyId
  };

  //Get appointments for particular Participant
  if (data.participantId) {
    getParams.userId = data.participantId;
  } else {
    getParams = {
      ...getParams,
      ...{ startDate: data.startDate, endDate: data.endDate }
    };
  }

  //Get appointments for all the sites
  if (data.isUserRole) {
    getParams.isUserRole = data.isUserRole;
  }

  return getAppointmentsForTelehealth.get(getParams);
}

export function getVisitsAppointmentList(data) {
  let getParams = {
    siteId: data.siteId,
    pId: data.pId,
    studyId: data.studyId
  };

  //Get appointments for particular Participant
  if (data.participantId) {
    getParams.userId = data.participantId;
  } else {
    getParams = {
      ...getParams,
      ...{
        startDate: data.startDate,
        endDate: data.endDate,
        search: data.search,
        filter: data.filter,
        sortOrder: data.sortOrder,
        sortValue: data.sortValue,
        pageSize: data.pageSize,
        pageNum: data.pageNum
      }
    };
  }

  //Get appointments for all the sites
  if (data.isUserRole) {
    getParams.isUserRole = data.isUserRole;
  }

  return getAppointmentsForVisits.get(getParams);
}

export function saveTelehealthSettings(data) {
  return saveTelehealthAppointmentSetting.save(
    {
      pId: data.piId
    },
    data
  );
}

export function getTelehealthSettings(data) {
  return getTelehealthAppointmentSetting.get({
    pId: data.pId,
    siteId: data.siteId
  });
}

export function getTelehealthRecurringAvailabilityDetail(data) {
  const siteID = data.siteId;
  return getRecurringAvailabilityDetail.get({
    siteID,
    id: data.id,
    pId: data.piId,
    studyId: data.studyId
  });
}

export function deleteTelehealthRecurringAvailability(data) {
  const siteID = data.siteId;
  return deleteRecurringAppointmentAvailability.delete({
    siteID,
    id: data.id,
    pId: data.piId,
    studyId: data.studyId
  });
}

export function updateTelehealthAppointmentStatus(data) {
  const appointmentId = data.id;
  return updateTelehealthAppointmentStatusResource.update(
    {
      appointmentId
    },
    data
  );
}

export function getDisabledList(studyId1, participantId, pId, studyId) {
  return getDisabledListResource.get({ studyId1, participantId, pId, studyId });
}
export function startTHcallRecording(data) {
  return startTHcallRecordingResource.save(data);
}

export function stopTHcallRecording(archiveId) {
  return stopTHcallRecordingResource.save({ archiveId: archiveId }, {});
}

export function sendArchiveDetails(data) {
  if (data.archiveDuration == null) {
    return sendArchiveDataFact.save(
      {
        telehealthSessionId: data.telehealthSessionId,
        participantId: data.participantId
      },
      data
    );
  } else {
    return updateArchiveDataFact.update(
      {
        telehealthSessionId: data.telehealthSessionId,
        participantId: data.participantId
      },
      data
    );
  }
}

export function getArchiveUrl(studyId, archiveId) {
  return getArchiveUrlResource.get({ studyId, archiveId });
}

export function downloadArchive(studyId, archiveId) {
  return downloadArchiveResource.get({
    studyId,
    archiveId
  });
}

export function getResearchTeamMembersFact(id1, id2, id3) {
  return getTeamMembersResource.get({
    studyId: id1,
    siteId: id2,
    appointmentId: id3
  });
}

export function addMembersToCallFact(id1, id2, id3, data) {
  return addToCallResource.save(
    {
      appointmentId: id1,
      studyId: id2,
      siteId: id3
    },
    data
  );
}

export function getRecordingDetailsFact(id1, id2) {
  return getRecordingResource.get({
    id1,
    participantId: id2
  });
}

export function getContactDetailsFact(appointmentId, pId) {
  return contactDetailsResource.get({
    appointmentId,
    pId
  });
}
export function getPI_ID(studyId, siteId) {
  return PI_IDResource.get({
    studyId,
    siteId
  });
}
export function getTelehealthVisitSlotsFact(studyId, siteId, pId, taskId, taskInstanceId, offset, timezone) {
  return telehealthVisitSlotResource.get({
    studyId,
    siteId,
    pId,
    taskId,
    taskInstanceId,
    offset,
    timezone
  });
}

export function scheduleAppointmentParticipantFact(data) {
  const studyId = data.studyId;
  const siteId = data.siteId;
  const pId = data.participantId;
  return scheduleAppointmentParticipantResource.update(
    {
      studyId,
      siteId,
      pId
    },
    data
  );
}

export function getVisitAppoitmentFact(studyId, siteId, appointmentId, pId) {
  return getVisitAppoitmentResource.get({
    studyId,
    siteId,
    appointmentId,
    pId
  });
}

export function updateVisitAppointmentFact(studyId, siteId, appointmentId, pId, data) {
  return updateVisitAppoitmentResource.update(
    {
      studyId,
      siteId,
      appointmentId,
      pId
    },
    data
  );
}
export function reScheduleAppointmentParticipantFact(rescheduleId, data) {
  const studyId = data.studyId;
  const siteId = data.siteId;
  const pId = data.participantId;
  return reScheduleAppointmentParticipantResource.update(
    {
      studyId,
      siteId,
      pId,
      rescheduleId
    },
    data
  );
}
export function deleteVisitAppointmentFact(studyId, siteId, appointmentId, pId, data) {
  return deleteVisitAppoitmentResource.delete(
    {
      studyId,
      siteId,
      appointmentId,
      pId
    },
    data
  );
}

export function getLegacyData(studyId) {
  return legacyData.get({ studyId });
}

export function getStatusList(studyId) {
  return getStatusListUrl.get({ studyId });
}

export function getReasonList(studyId) {
  return getReasonListUrl.get({ studyId });
}
